import { forwardRef, memo, useMemo, useState } from "react"

import { CheckbokItem } from "../CheckList/CheckbokItem"

import { AutocompleteCheckListProps } from "./types"

export const AutocompleteCheckList = memo(forwardRef<HTMLDivElement, AutocompleteCheckListProps>(
    ({ items, selectedItems, onChange, placeholder = "Search...", dataTestId, leftIcon, searchByValue = true }: AutocompleteCheckListProps, ref) => {
        const [searchTerm, setSearchTerm] = useState("")

        const filteredItems = useMemo(() => {
            if (!searchTerm) return items

            const lowerSearch = searchTerm.trim().toLowerCase()
            return items.filter(item =>
                item.label.toLowerCase().includes(lowerSearch) ||
                (searchByValue && item.value.toLowerCase().includes(lowerSearch))
            )
        }, [items, searchTerm, searchByValue])

        return (
            <div ref={ref} className="flex flex-col rounded-md bg-base-popover text-xs pb-1">
                <div className="relative">
                    <input
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder={placeholder}
                        className={`w-full h-10 px-3 border-b border-base-input bg-base-background text-base-foreground placeholder:text-base-foreground/50 focus:outline-none outline-none ${leftIcon ? 'pl-10' : ''}`}
                    />
                    {leftIcon && (
                        <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none [&>svg]:w-4 [&>svg]:h-4 [&>svg]:text-base-mutedForeground">
                            {leftIcon}
                        </div>
                    )}
                </div>

                <div className="flex flex-col gap-2 max-h-[200px] overflow-y-auto ml-2 mt-3">
                    {filteredItems.length > 0 ? (
                        filteredItems.map(item => (
                            <CheckbokItem
                                key={item.value}
                                item={item}
                                selectedItems={selectedItems}
                                onChange={onChange}
                                dataTestId={dataTestId}
                            />
                        ))
                    ) : (
                        <div className="text-center text-xs text-base-foreground/50">
                            No results found
                        </div>
                    )}
                </div>
            </div>
        )
    }
))

AutocompleteCheckList.displayName = 'AutocompleteCheckList'

